/**
 * Per-graph values the cards and edges need but that must not live in node/edge data: putting
 * them there would give every node a new data object whenever a callback or status changes and
 * re-render all ~300 cards.
 */
import { createContext, useContext } from 'react';

const noop = () => {};

export const DEFAULT_GRAPH_CONTEXT = {
  // Path highlight (hover/focus) and the hovered/focused card itself.
  highlightStore: null,
  activeStore: null,
  // One shared react-tooltip per graph instance for the figure tooltips.
  tooltipId: '',
  figuresStatus: 'loaded',
  variant: 'mini',
  // True while the PNG is drawn: cards render in full, whatever the zoom.
  isRenderingImage: false,
  onToggleNodeCollapsed: noop,
  onShowAllFiltered: noop
};

export const GraphContext = createContext(DEFAULT_GRAPH_CONTEXT);

export const useGraphContext = () => useContext(GraphContext);
